import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useBrandKit } from '../contexts/BrandKitContext';

const { FiEye, FiDownload, FiShare2, FiLayers } = FiIcons;

const PreviewPage = () => {
  const { selectedKit } = useBrandKit();

  const mockPreviews = [
    {
      id: 1,
      name: 'Business Card',
      type: 'card',
      thumbnail: 'https://via.placeholder.com/300x200/f3f4f6/6b7280?text=Business+Card'
    },
    {
      id: 2,
      name: 'Letterhead',
      type: 'document',
      thumbnail: 'https://via.placeholder.com/300x200/f3f4f6/6b7280?text=Letterhead'
    },
    {
      id: 3,
      name: 'Presentation',
      type: 'presentation',
      thumbnail: 'https://via.placeholder.com/300x200/f3f4f6/6b7280?text=Presentation'
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Preview</h1>
          <p className="text-gray-600">Preview your branded materials</p>
        </div>

        {/* Brand Kit Info */}
        {selectedKit && (
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 mb-8">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Current Brand Kit</h2>
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiLayers} className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">{selectedKit.name}</h3>
                <p className="text-sm text-gray-600">{selectedKit.description}</p>
              </div>
            </div>
          </div>
        )}

        {/* Preview Grid */}
        {selectedKit ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {mockPreviews.map((preview, index) => (
              <motion.div
                key={preview.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow"
              >
                <div className="aspect-w-3 aspect-h-2 bg-gray-100">
                  <img
                    src={preview.thumbnail}
                    alt={preview.name}
                    className="w-full h-48 object-cover"
                  />
                </div>
                
                <div className="p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">{preview.name}</h3>
                  <p className="text-sm text-gray-600 mb-4">Branded {preview.type}</p>
                  
                  <div className="flex space-x-2">
                    <button className="flex items-center space-x-1 bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm">
                      <SafeIcon icon={FiEye} className="w-4 h-4" />
                      <span>View</span>
                    </button>
                    <button className="flex items-center space-x-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition-colors text-sm">
                      <SafeIcon icon={FiDownload} className="w-4 h-4" />
                      <span>Download</span>
                    </button>
                    <button className="flex items-center space-x-1 bg-gray-600 text-white px-3 py-2 rounded-lg hover:bg-gray-700 transition-colors text-sm">
                      <SafeIcon icon={FiShare2} className="w-4 h-4" />
                      <span>Share</span>
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 text-center">
            <SafeIcon icon={FiEye} className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">No Brand Kit Selected</h3>
            <p className="text-gray-600">Please create or select a brand kit to see previews</p>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default PreviewPage;